module.exports = __webpack_public_path__ + "static/media/arrow-from-top.0c6ae700.svg";